import * as d3 from 'd3'

export default {

  methods: {

    draw_Forms() {

      this.canvasForms = this.svg
      .append('g')
      .attr('transform', `translate(0, 10)`)
      .attr('font-family', 'roboto')
      .attr('cursor', 'default')
      
      if(this.title.main) {
        this.canvasForms
        .append('text')
        .attr('x', this.title.main.x).attr('y', this.title.main.y + this.title.main.tSize*0.36)
        .attr('fill', this.title.main.tColor).attr('font-size', this.title.main.tSize)
        .attr('text-anchor', 'start')
        .text(this.title.main.name)
      }

      if(this.title.sub) {
        this.canvasForms
        .append('text')
        .attr('x', this.title.sub.x).attr('y', this.title.sub.y + this.title.sub.tSize*0.36)
        .attr('fill', this.title.sub.tColor).attr('font-size', this.title.sub.tSize)
        .attr('text-anchor', 'start')
        .text(this.title.sub.name)
      }

      this.draw_Status()

      if (this.sundries) {
        let sunData = this.JQueries.sundriesConfig && this.JQueries.sundriesConfig.SQL ? this.Queries[this.JQueries.sundriesConfig.SQL][0] : this.DataItems[0]
        if(this.sundries.length > 0) this.gmx_Sundries(this.svg, this.sundries, sunData, this.JQueries.sundriesConfig.server)
      }
    },

  } 
}